<script setup lang="ts">
  import { toRef } from 'vue';

  import { SearchCombobox } from '@/shared/ui';

  import {
    useProtheusRecipientSearch,
    type ProtheusRecipientOption,
  } from '../model/useProtheusRecipientSearch';

  const props = withDefaults(
    defineProps<{
      modelValue: string;
      options: ProtheusRecipientOption[];
      placeholder: string;
      searchPlaceholder: string;
      notFoundMessage: string;
      loading?: boolean;
      triggerClass?: string;
    }>(),
    {
      loading: false,
      triggerClass: undefined,
    }
  );

  const emit = defineEmits<{
    (e: 'update:modelValue', value: string): void;
  }>();

  const { options, emptyMessage, selectedLabel, selectedValue, search } =
    useProtheusRecipientSearch(
      toRef(props, 'options'),
      toRef(props, 'modelValue'),
      props.notFoundMessage
    );

  const handleSelect = (value: string) => {
    emit('update:modelValue', value);
  };
</script>

<template>
  <SearchCombobox
    :model-value="selectedValue"
    :options="options"
    :initial-label="selectedLabel"
    :loading="loading"
    :empty-message="emptyMessage"
    :class="triggerClass"
    trigger-icon="arrow-down"
    :placeholder="placeholder"
    :search-placeholder="searchPlaceholder"
    @update:model-value="handleSelect"
    @search="search"
  />
</template>
